import { XIcon } from "@heroicons/react/outline";
import moment from "moment";
import { FC } from "react";

import { SelectedRegistriesGridProps } from "./types";

const SelectedRegistriesGrid: FC<SelectedRegistriesGridProps> = ({
  selectedRegistries,
  onRemoveRegistry,
}) => {
  if (selectedRegistries.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Selected Prompt Templates ({selectedRegistries.length})
      </label>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {selectedRegistries.map(registry => (
          <div
            key={registry.id}
            className="group relative flex cursor-pointer items-center justify-between rounded-md border border-gray-200 bg-white p-3 transition-colors hover:border-blue-300 hover:bg-blue-50"
            onClick={() => onRemoveRegistry(registry.id)}
          >
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-sm font-medium text-gray-900 group-hover:text-blue-700">
                {registry.prompt_name}
              </h3>
              {registry.last_version_created_at && (
                <p className="text-xs text-gray-500">
                  {moment(registry.last_version_created_at).format("MMM DD, YYYY")}
                </p>
              )}
            </div>
            <XIcon className="ml-2 h-4 w-4 flex-shrink-0 text-gray-400 group-hover:text-blue-500" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedRegistriesGrid;
